import Client from '../../../../api/client';
import { inject } from 'aurelia-framework';
import { FlashService } from '../../../../flash/flash-service';
import { DialogView } from '../../../../view/dialog-view';
import { DialogService } from 'aurelia-dialog';

@inject(Client, FlashService, DialogService)
export class BussMailPlannerService {
    constructor(client, flash, dialog) {
        this.client = client;
        this.flash = flash;
        this.flash.hideAutomatically = true;
        this.dialog = dialog;
        this.selectedPin = [];
        this.handlePinEditSubmit = this.handlePinEditSubmit.bind(this);
    }
    async mailPlannerFormRequest(value) {
        const data = await this.client.post(
            `event-planner/bus-mailing-list`,
            value
        );

        return data?.data;
    }

    async handleBusMailPlannerFiltersSubmit(form, object, googleMaps) {
        const values = form.formService.getValue();
        const data = await this.mailPlannerFormRequest({
            ...values,
            mailingPlanner: {
                id: object.id,
                modelId: 'humboldt/mailing-planner',
            },
        });
        if (data) {
            this.updateGoogleMapPins(data?.pins, googleMaps, form, object);
        }
    }
    async loadInitialPins(id, googleMaps, form, object) {
        const data = await this.mailPlannerFormRequest({
            mailingPlanner: {
                id: id,
                modelId: 'humboldt/mailing-planner',
            },
        });
        if (data) {
            this.updateGoogleMapPins(data?.pins, googleMaps, form, object);
        }
    }
    async addOnClickToMarker(marker, pin, googleMaps, form, object) {
        google.maps.event.addListener(marker, 'click', async () => {
            const index = this.selectedPin.findIndex(
                (p) => p.pin.referenceId === pin.referenceId
            );
            if (index > -1) {
                this.selectedPin.splice(index, 1);
            } else {
                this.selectedPin.push({ pin, marker });
            }
        });
    }

    updateGoogleMapPins(pinsData, googleMaps, form, object) {
        googleMaps.clearMarkers();
        if (pinsData.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            pinsData.forEach((pin) => {
                const lat = parseFloat(pin.latitude);
                const lng = parseFloat(pin.longitude);

                const location = {
                    address: {
                        coordinates: {
                            lat: lat,
                            lng: lng,
                        },
                    },
                };
                bounds.extend({ lat, lng });

                const iconUrl = pin.journeysAvailable
                    ? 'https://humboldt-tzcd-file.s.io/image/resize/50x50/0120d92f-2e5b-4800-b74c-2983244e8eb4/pngkey-com-google-pin-png-480344.png'
                    : 'https://humboldt-tzcd-file.s.io/image/resize/50x50/8635f32d-cb33-4694-a6ff-e15d7aef9468/google-maps-pin.png';

                const icon = { url: iconUrl };

                const marker = googleMaps.addMarkerToMap(
                    location,
                    () => {},
                    icon,
                    false
                );

                this.addOnHoverWindowToMarker(marker, pin, googleMaps);
                this.addOnClickToMarker(marker, pin, googleMaps, form, object);
            });
            googleMaps.map.fitBounds(bounds);
        }
    }

    addOnHoverWindowToMarker(marker, pin, googleMaps) {
        const infoWindow = new google.maps.InfoWindow({
            disableAutoPan: true,
        });

        google.maps.event.addListener(marker, 'mouseover', () => {
            infoWindow.setContent(`
        <div style="padding:4px; max-width:300px;">
            ${pin.tooltip
                .map(
                    (tip) =>
                        `<div style="margin-bottom:4px">${tip.title} ${tip.amount}</div> `
                )
                .join(``)}
        </div>
        <style>
            .gm-ui-hover-effect { display: none !important; }
            .gm-style-iw-c button { display: none !important; }
        </style>
    `);
            infoWindow.open(googleMaps.map, marker);
        });

        google.maps.event.addListener(marker, 'mouseout', () => {
            infoWindow.close();
        });
    }

    async handlePinEditSubmit(form, object, googleMaps) {
        const values = form.formService.getValue();
        const data = {
            fromDate: values.fromDate,
            routeItinerary: values.routeItinerary,
            mailingPlanner: {
                id: object.id,
                modelId: 'humboldt/mailing-planner',
            },
            busStops: this.selectedPin.map((pin) => ({
                id: pin.pin.referenceId,
                modelId: 'tourism-bus/busstop',
            })),
        };

        try {
            const response = await this.client.post(
                `event-planner/update-bus-stops`,
                data
            );

            if (response.ok) {
                this.flash.success('Die Routen wurden aktualisiert');
                this.selectedPin = [];
            }
        } catch (error) {
            console.error(error);
            this.flash.error(
                error?.data?.localizedMessage ||
                    'Fehler beim Aktualisieren des Pins'
            );
        }
    }
}
